import { render, staticRenderFns } from "./AttachmentCell.vue?vue&type=template&id=164b087e&scoped=true&"
import script from "./AttachmentCell.vue?vue&type=script&lang=js&"
export * from "./AttachmentCell.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentCell.vue?vue&type=style&index=0&id=164b087e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b087e",
  null
  
)

export default component.exports